import React from "react"

import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./icon.module.scss"

const Icon = ({ icon, category, spin, image, standalone, animation, size }) =>
  category ? (
    <Image
      alt={icon}
      width={50}
      className={`${styles.icon} ${styles.icon__image} ${styles[`icon__${size}`]}`}
      {...image}
    />
  ) : (
    <span
      className={`material-icons material-symbols-outlined ${
        spin ? styles.icon__spin : ""
      } ${styles.icon} ${standalone ? "" : styles.icon__inline} ${
        styles.icon__font
      } ${animation ? styles[`icon__${animation}`] : ""}`}
    >
      {icon}
    </span>
  )

export default Icon

Icon.propTypes = {
  icon: PropTypes.string,
  category: PropTypes.string,
  spin: PropTypes.bool,
  image: PropTypes.object,
  animation: PropTypes.string,
  standalone: PropTypes.bool,
  size: PropTypes.string,
}

Icon.defaultProps = {
  icon: "",
  category: null,
  spin: false,
  image: null,
  animation: "",
  standalone: true,
  size: "large",
}
